import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { motion } from "framer-motion";

const StatsSection = ({ stats, title,onCardClick }) => {
  return (
    <Box mb={8}>
      {title && (
        <Typography
          variant="h5"
          fontWeight={600}
          color="text.primary"
          mb={3}
          sx={{
            letterSpacing: "0.3px",
            textTransform: "capitalize",
          }}
        >
          {title}
        </Typography>
      )}

      <Box
        display="flex"
        flexWrap="wrap"
        gap={3}
        sx={{
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.03 }}
            style={{ flex: "1 1 180px", maxWidth: 260 }}
          >
            <Card
              onClick={()=>onCardClick(stat.key)}
              sx={{
                p: 4,
                borderRadius: "16px",
                background: stat.bg || "#ffffff",
                border: "1px solid rgba(0,0,0,0.06)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                gap: 3,
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  transform: "translateY(-3px)",
                },
              }}
            >
              <Box
                sx={{
                  fontSize: "1.9rem",
                  background: stat.color,
                  color: "#fff",
                  borderRadius: "50%",
                  width: 52,
                  height: 52,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
                }}
              >
                {stat.icon}
              </Box>

              <Box>
                <Typography
                  variant="h5"
                  fontWeight={700}
                  color="text.primary"
                  sx={{ mb: 0.5 }}
                >
                  {stat.value}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ opacity: 0.8 }}
                >
                  {stat.label}
                </Typography>
              </Box>
            </Card>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default StatsSection;
